'use strict';

var React = require('react');

var SvgWorkIcon = function SvgWorkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.965 11.238a.986.986 0 0 1 .035.262v.5a1 1 0 1 1-2 0v-.5c0-.09.012-.178.035-.262a12.75 12.75 0 0 1-3.278-.69l-.257-.09a.75.75 0 1 1 .5-1.415l.256.09a11.25 11.25 0 0 0 7.488 0l.256-.09a.75.75 0 1 1 .5 1.414l-.257.09a12.75 12.75 0 0 1-3.278.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 5.5v-.25a2.25 2.25 0 0 1 2.25-2.25h2.5a2.25 2.25 0 0 1 2.25 2.25v.25h.25a3.25 3.25 0 0 1 3.25 3.25v5a3.25 3.25 0 0 1-3.25 3.25h-7.5a3.25 3.25 0 0 1-3.25-3.25v-5a3.25 3.25 0 0 1 3.25-3.25h.25Zm1.5-.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v.25h-4v-.25Zm-1.75 1.75a1.75 1.75 0 0 0-1.75 1.75v5c0 .966.784 1.75 1.75 1.75h7.5a1.75 1.75 0 0 0 1.75-1.75v-5a1.75 1.75 0 0 0-1.75-1.75h-7.5Z"
  }));
};
SvgWorkIcon.displayName = "WorkIcon";

exports.SvgWorkIcon = SvgWorkIcon;
